import { Render } from 'shared-components';
import { Config, Data } from '@measured/puck';

interface IProps {
  data: Data;
  config: Config;
}

const HomePage = ({ data, config }: IProps) => {
  return <Render config={config} data={data} />;
};

export default HomePage;
